import { render, staticRenderFns } from "./TranProgramActivityUpdate.vue?vue&type=template&id=6f63ab4e&scoped=true"
import script from "./TranProgramActivityUpdate.vue?vue&type=script&lang=js"
export * from "./TranProgramActivityUpdate.vue?vue&type=script&lang=js"
import style0 from "./TranProgramActivityUpdate.vue?vue&type=style&index=0&id=6f63ab4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f63ab4e",
  null
  
)

export default component.exports